// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Array contains list of on-file wallets and merchants that already have input pan tokenized
 * @export
 * @interface IExistingOnFileWallet
 */
export interface IExistingOnFileWallet {
    /**
     * dentifier of button or log asset of wallet, usable in Get Assets API for fetching that asset
     * @type {string}
     * @memberof IExistingOnFileWallet
     */
    asset_id: string;
    /**
     * The name of the token requester to be displayed to the end user
     * @type {string}
     * @memberof IExistingOnFileWallet
     */
    consumer_facing_entity_name: string;
    /**
     * Sequence number in list
     * @type {string}
     * @memberof IExistingOnFileWallet
     */
    sequence_number: string;
    /**
     * Identifier of wallet or merchant that can accept a push provision
     * @type {string}
     * @memberof IExistingOnFileWallet
     */
    wallet_id: string;
    /**
     * The type of the token requestor WALLET MERCHANT
     * @type {string}
     * @memberof IExistingOnFileWallet
     */
    wallet_type: string;
    /**
     * Identifier of input pan present at on-file merchant wallet
     * @type {string}
     * @memberof IExistingOnFileWallet
     */
    token_reference_id?: string | null;
}

/**
 * Check if a given object implements the IExistingOnFileWallet interface.
 */
export function instanceOfIExistingOnFileWallet(value: object): value is IExistingOnFileWallet {
    if (!('asset_id' in value) || value['asset_id'] === undefined) return false;
    if (!('consumer_facing_entity_name' in value) || value['consumer_facing_entity_name'] === undefined) return false;
    if (!('sequence_number' in value) || value['sequence_number'] === undefined) return false;
    if (!('wallet_id' in value) || value['wallet_id'] === undefined) return false;
    if (!('wallet_type' in value) || value['wallet_type'] === undefined) return false;
    return true;
}

export function IExistingOnFileWalletFromJSON(json: any): IExistingOnFileWallet {
    return IExistingOnFileWalletFromJSONTyped(json, false);
}

export function IExistingOnFileWalletFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExistingOnFileWallet {
    if (json == null) {
        return json;
    }
    return {
        
        'asset_id': json['assetId'],
        'consumer_facing_entity_name': json['consumerFacingEntityName'],
        'sequence_number': json['sequenceNumber'],
        'wallet_id': json['walletId'],
        'wallet_type': json['walletType'],
        'token_reference_id': json['tokenReferenceId'] == null ? undefined : json['tokenReferenceId'],
    };
}

export function IExistingOnFileWalletToJSON(json: any): IExistingOnFileWallet {
    return IExistingOnFileWalletToJSONTyped(json, false);
}

export function IExistingOnFileWalletToJSONTyped(value?: IExistingOnFileWallet | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetId': value['asset_id'],
        'consumerFacingEntityName': value['consumer_facing_entity_name'],
        'sequenceNumber': value['sequence_number'],
        'walletId': value['wallet_id'],
        'walletType': value['wallet_type'],
        'tokenReferenceId': value['token_reference_id'],
    };
}

